import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.map.js";
import User from "../user/User";
import JsonMappedModel from "../helpers/JsonMappedModel";
import CountryCollection from "../country/CountryCollection";
import UserCollection from "../user/UserCollection";
import ProductCollection from "../product/ProductCollection";
import WarehousePricesCollection from "./WarehousePricesCollection";
import ECommerceSdkAccountCollection from "../ECommerceSdk/ECommerceSdkAccountCollection";
import SpecialWarehousePricesCollection from "./SpecialWarehousePricesCollection";
var _attributes = /*#__PURE__*/new WeakMap();
export default class Warehouse extends JsonMappedModel {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [Warehouse.id_attribute_name]: null,
      [Warehouse.warehouse_user_attribute_name]: User,
      [Warehouse.user_attribute_name]: User,
      [Warehouse.warehouse_name_attribute_name]: null,
      [Warehouse.warehouse_email_attribute_name]: null,
      [Warehouse.warehouse_phone_attribute_name]: null,
      [Warehouse.warehouse_skype_id_attribute_name]: null,
      [Warehouse.created_at_attribute_name]: null,
      [Warehouse.warehouse_countries_attribute_name]: CountryCollection,
      [Warehouse.warehouse_call_agents_attribute_name]: UserCollection,
      [Warehouse.warehouse_advertisers_attribute_name]: UserCollection,
      [Warehouse.warehouse_products_attribute_name]: ProductCollection,
      [Warehouse.last_30_days_earnings_attribute_name]: null,
      [Warehouse.warehouse_prices_attribute_name]: WarehousePricesCollection,
      [Warehouse.has_call_agent_attribute_name]: true,
      [Warehouse.country_select_type_attribute_name]: Warehouse.MULTIPLE_COUNTRY_SELECT_TYPE,
      [Warehouse.special_warehouse_prices_attribute_name]: SpecialWarehousePricesCollection,
      [Warehouse.sdk_accounts_attribute_name]: ECommerceSdkAccountCollection,
      [Warehouse.creator_id_attribute_name]: null,
      [Warehouse.creator_attribute_name]: null
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getNameAttributeName() {
    return this.warehouse_name_attribute_name;
  }
  static getCreatorIdAttributeName() {
    return this.creator_id_attribute_name;
  }
  static getWarehousePricesAttributeName() {
    return this.warehouse_prices_attribute_name;
  }
  static getHasCallAgentAttributeName() {
    return this.has_call_agent_attribute_name;
  }
  static getUserAttributeName() {
    return this.user_attribute_name;
  }
  static getWarehouseUserAttributeName() {
    return this.warehouse_user_attribute_name;
  }
  static getEmailAttributeName() {
    return this.warehouse_email_attribute_name;
  }
  static getPhoneAttributeName() {
    return this.warehouse_phone_attribute_name;
  }
  static getSkypeIdAttributeName() {
    return this.warehouse_skype_id_attribute_name;
  }
  static getCreatedAtAttributeName() {
    return this.created_at_attribute_name;
  }
  getCreationDate() {
    return this.getAttribute(Warehouse.getCreatedAtAttributeName());
  }
  getEmail() {
    return this.getAttribute(Warehouse.warehouse_email_attribute_name);
  }
  getId() {
    return this.getAttribute(Warehouse.id_attribute_name);
  }
  getName() {
    return this.getAttribute(Warehouse.warehouse_name_attribute_name);
  }
  getCallAgents() {
    return this.getAttribute(Warehouse.warehouse_call_agents_attribute_name);
  }
  getMainCallAgent() {
    let callAgents = this.getCallAgents();
    return Array.isArray(callAgents) ? callAgents.find(callAgent => callAgent instanceof User ? callAgent.isMainCallAgent() : false) : null;
  }
  getSpecialPrices() {
    var _this$getAttribute;
    return (_this$getAttribute = this.getAttribute(Warehouse.special_warehouse_prices_attribute_name)) !== null && _this$getAttribute !== void 0 ? _this$getAttribute : [];
  }
  getPrices() {
    return this.getAttribute(Warehouse.warehouse_prices_attribute_name);
  }
  getLastMonthConfirmedSales() {
    return this.getAttribute(Warehouse.last_30_days_earnings_attribute_name);
  }
  getUser() {
    var _this$getAttribute2;
    return (_this$getAttribute2 = this.getAttribute(Warehouse.warehouse_user_attribute_name)) !== null && _this$getAttribute2 !== void 0 ? _this$getAttribute2 : this.getAttribute(Warehouse.user_attribute_name);
  }
  getRoleName() {
    let user = this.getUser();
    return user instanceof User ? user.getRoleName() : null;
  }
  getStatus() {
    let user = this.getUser();
    return user instanceof User ? user.getStatus() : null;
  }
  getImageUrl() {
    let user = this.getUser();
    return user instanceof User ? user.getImageUrl() : null;
  }
  isActive() {
    let user = this.getUser();
    return user instanceof User && user.isActive();
  }
  getPhone() {
    return this.getAttribute(Warehouse.warehouse_phone_attribute_name);
  }
  getCountriesShippingPrices() {
    var _this$getAttribute3;
    return (_this$getAttribute3 = this.getAttribute(Warehouse.warehouse_prices_attribute_name)) !== null && _this$getAttribute3 !== void 0 ? _this$getAttribute3 : [];
  }
  getUserCountry() {
    let user = this.getUser();
    return user instanceof User ? user.getCountry() : null;
  }
  getWarehouseSelectObject(text = 'text', value = 'value', otherFields = []) {
    let obj = {
      [text !== null && text !== void 0 ? text : 'text']: this.getName(),
      [value !== null && value !== void 0 ? value : 'value']: this.getId()
    };
    if (otherFields.includes('products')) obj.products = this.getProducts();
    return obj;
  }
  getProducts() {
    return this.getAttribute(Warehouse.warehouse_products_attribute_name);
  }
}
_defineProperty(Warehouse, "WORLD_WIDE_COUNTRY_SELECT_TYPE", 'world-wide');
_defineProperty(Warehouse, "MULTIPLE_COUNTRY_SELECT_TYPE", 'multiple-countries');
_defineProperty(Warehouse, "id_attribute_name", 'warehouse_id');
_defineProperty(Warehouse, "warehouse_user_attribute_name", 'warehouse_user');
_defineProperty(Warehouse, "user_attribute_name", 'user');
_defineProperty(Warehouse, "warehouse_name_attribute_name", 'warehouse_name');
_defineProperty(Warehouse, "warehouse_email_attribute_name", 'warehouse_email');
_defineProperty(Warehouse, "warehouse_phone_attribute_name", 'warehouse_phone');
_defineProperty(Warehouse, "warehouse_skype_id_attribute_name", 'warehouse_skype_id');
_defineProperty(Warehouse, "created_at_attribute_name", 'created_at');
_defineProperty(Warehouse, "warehouse_countries_attribute_name", 'warehouse_countries');
_defineProperty(Warehouse, "warehouse_call_agents_attribute_name", 'warehouse_call_agents');
_defineProperty(Warehouse, "warehouse_advertisers_attribute_name", 'warehouse_advertisers');
_defineProperty(Warehouse, "warehouse_products_attribute_name", 'warehouse_products');
_defineProperty(Warehouse, "last_30_days_earnings_attribute_name", 'last_30_days_earnings');
_defineProperty(Warehouse, "warehouse_prices_attribute_name", 'warehouse_prices');
_defineProperty(Warehouse, "has_call_agent_attribute_name", 'has_call_agent');
_defineProperty(Warehouse, "country_select_type_attribute_name", 'country_select_type');
_defineProperty(Warehouse, "special_warehouse_prices_attribute_name", 'special_warehouse_prices');
_defineProperty(Warehouse, "sdk_accounts_attribute_name", 'sdk_accounts');
_defineProperty(Warehouse, "creator_id_attribute_name", 'creator_id');
_defineProperty(Warehouse, "creator_attribute_name", 'creator');